export default `
    precision highp float;
    precision highp int;
    varying vec2 vUv;
    // varying float noise;
    uniform sampler2D tMap;
    uniform float time;
    uniform float factor;

    varying vec3 vNormal;
    varying vec3 newPosition;

    float rand(float n){return fract(sin(n) * 43758.5453123);}

    float pnoise(float p){
        float fl = floor(p);
        float fc = fract(p);
        return mix(rand(fl), rand(fl + 1.0), fc);
    }

    vec2 matcap(vec3 eye, vec3 normal) {
        vec3 reflected = reflect(eye, normal);
        float m = 2.8284271247461903 * sqrt( reflected.z+1.0 );
        return reflected.xy / m + 0.5;
    }

    void main() {

        // get a random offset
        // float r = .1 * random( vec2( 12.9898, 78.233));

        // to get the right RGB colour
        vec2 tPos = vec2( vUv.x + ( 0.5 * factor * ((pnoise(time+vUv.y) - 0.5))), vUv.y + ( 0.5 * factor * ((pnoise(time+vUv.x) - 0.5))));

        vec4 color = texture2D( tMap, tPos );

        // color.r = newPosition.y * 0.1;
        
        gl_FragColor = vec4( color.rgb , 1.0 );
    }
`;